<div
    class="tw-mt-5 lg:tw-mt-10 tw-px-6 tw-py-6 lg:tw-px-20 tw-flex tw-flex-col lg:tw-flex-row tw-items-center tw-justify-between tw-gap-10"
>
    <div class="tw-text-left">
        <p
            class="tw-w-full tw-text-[24px] md:tw-text-[30px] tw-text-[#0F3172] tw-font-bold tw-leading-[140%]"
        >
            {{ "NEW_ABOUT_US.TITLE" | translate }}
        </p>
        <p
            class="tw-py-1 tw-text-[#1A202C] tw-font-normal !tw-text-[14px] lg:!tw-text-[16px] tw-leading-5 md:tw-leading-[150%]"
        >
            {{ "NEW_ABOUT_US.DESCRIPTION" | translate }}
        </p>
        <p
            class="tw-text-[#1A202C] tw-font-normal !tw-text-[14px] lg:!tw-text-[16px] tw-leading-5 md:tw-leading-[150%]"
        >
            {{ "NEW_ABOUT_US.DESCRIPTION1" | translate }}
        </p>
        <p
            class="tw-text-[#1A202C] tw-font-normal !tw-text-[14px] lg:!tw-text-[16px] tw-leading-5 md:tw-leading-[150%]"
        >
            {{ "NEW_ABOUT_US.DESCRIPTION2" | translate }}
        </p>
        <button
            class="tw-mt-6 tw-text-[16px] tw-font-semibold tw-text-[#FFFFFF] tw-bg-[#FFA53C] tw-rounded-[24px] tw-h-[48px] tw-w-[180px] tw-flex tw-items-center tw-justify-center"
            (click)="onRegisterClick()"
            ga-event-id="register_now_button_about_imsme_click"
            ga-event-category="About imSME Button"
            ga-event-label="Register Now Main Button Click"
            ga-track="track"
        >
            {{ "NEW_ABOUT_US.REGISTER_NOW" | translate }}
        </button>
    </div>
</div>
